import { defineComponent } from "vue";
import { storeToRefs } from "pinia";
import { useMaintenanceScheduleStore } from "../maintenanceScheduleStore";
export default defineComponent({
    name: "MaintenanceScheduleYears",
    setup() {
        const store = useMaintenanceScheduleStore();
        const { questionYearAnswers, questionYearAnswer } = storeToRefs(store);
        function answered(event) {
            store.updateQuestionYearAnswer();
            const selectedYear = event.currentTarget;
            updateSelectedYear(selectedYear);
        }
        function updateSelectedYear(selectedYearElement) {
            const selectedAttribute = "aria-selected";
            const yearOptions = Array.from(selectedYearElement.children, (element) => element);
            yearOptions.forEach((yearOptionElement) => {
                if (yearOptionElement.getAttribute(selectedAttribute)) {
                    yearOptionElement.removeAttribute(selectedAttribute);
                    return;
                }
            });
            const selectedOptionElement = selectedYearElement.options[selectedYearElement.selectedIndex];
            selectedOptionElement.setAttribute(selectedAttribute, "true");
        }
        return {
            questionYearAnswers,
            questionYearAnswer,
            answered,
        };
    },
});
